import { produce } from 'immer';

import {
  GET_HACKATHON_MATCHES_REQUEST,
  GET_HACKATHON_MATCHES_SUCCESS,
  GET_HACKATHON_MATCHES_FAILURE,
} from './constants';

const initialState = {
  loading: false,
  matches: [],
  error: '',
};

export default function HackathonMatchesReducer(baseState = initialState, action) {
  return produce(baseState, (state) => {
    switch (action.type) {
      case GET_HACKATHON_MATCHES_REQUEST:
        state.loading = true;
        state.error = '';
        break;
      case GET_HACKATHON_MATCHES_SUCCESS:
        state.loading = false;
        state.error = '';
        state.matches = action.matches;
        break;
      case GET_HACKATHON_MATCHES_FAILURE:
        state.loading = false;
        state.error = action.error;
        break;
      default:
        break;
    }
  });
}
